import { AccordionContent, AccordionTrigger, Accordion as ZapposAccordion, AccordionItem as ZapposAccordionItem } from '@mweb/zappos-ui/Accordion';

import { cn } from 'helpers/classnames';
import useMartyContext from 'hooks/useMartyContext';

export interface AccordionProps {
  heading: string;
  children: React.ReactNode;
}

export const Accordion = ({ heading, children }: AccordionProps) => {
  const { testId } = useMartyContext();

  return (
    <ZapposAccordion key={`accordion-${heading}`} type="single" collapsible defaultValue={heading}>
      <ZapposAccordionItem value={heading} className="border-b border-solid border-gray-300">
        <AccordionTrigger
          className={cn(
            'bg-transparent flex flex-1 cursor-pointer appearance-none items-center justify-between border-0 px-0 py-4 font-semibold outline-offset-1 outline-button-focus transition-all [&[data-state=closed]>[data-close-icon]]:hidden [&[data-state=open]>[data-open-icon]]:hidden',
            'zappos:heading-xxs'
          )}
          data-test-id={testId(`footerAccordionTrigger-${heading?.replace(/\s/g, '-')}`)}
        >
          {heading}
        </AccordionTrigger>
        <AccordionContent>{children}</AccordionContent>
      </ZapposAccordionItem>
    </ZapposAccordion>
  );
};
